import ReportModel from "@/models/reports/report_model";

export default class BalanceSheetModel extends ReportModel {
    constructor() {
        super();
    }
    prepareHeaders(data) {
        this.headers = [
            { text: '', value: 'name' }
        ];

        //add the periods and the percentage headers
        for (let period in data[0].periods) {
            let heading = {
                text: data[0].periods[period].period,
                value: data[0].periods[period].period
            }
            this.headers.push(heading);
        }

        this.headers.push({ text: '%', value: 'percentage' })
    }
    parseDataForDataTable(item) {
        let data = {};

        for (let period in item.periods) {
            data[item.periods[period].period] = item.periods[period].amount;
        }

        data.name = item.name;
        data.group = item.name;
        data.percentage = '100%';
        data.type = item.type;
        data.level = item.level;

        this.data.push(data);

        if (item.children) {
            this.parseChildRows(item, item)
        }
    }
    //the parseChildRows gets the current row, the primary one that is given at the beginning and the level of the category
    parseChildRows(row, primary) {
        if (!row.children) {
            return;
        }

        //fill the row with the data
        row.children.forEach((child) => {
            let data = {};
            for (let period in child.periods) {
                data[child.periods[period].period] = child.periods[period].amount;
            }

            data.name = child.name;
            data.group = primary.name;

            let percentage;
            if (primary.account_amount == 0) {
                percentage = 0;
            } else {
                percentage = child.account_amount / primary.account_amount * 100;
            }

            data.percentage = (percentage % 1 === 0 ? percentage : percentage.toFixed(2)) + '%';

            data.type = child.type;
            data.level = child.level;

            this.data.push(data);

            if (child.children) {
                this.parseChildRows(child, primary)
            }
        })
    }
}